/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/plugins/jquery/aaTooltip.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/plugins/jquery.aaTooltip.js
**/

/*------------------------------------*\
$ aaTooltip
\*------------------------------------*/
var aaTooltips = {};    //Global Array for Tooltip Instances

/**
 * Add aaTooltip plugin to jQuery Library
 */
(function($){
    $.fn.aaTooltip = function(options) {
    	var self = {};
    	self.source = this;

        self.aaTooltip = function(elements, options){
        	return new (function() {
        		// Variables declaration
        		var self = this;
        		var _animate, _clickEvent, _fade, _ua, _HTML;
        		var _tooltipCloseText = AAcom.prototype.getProperty('tooltip.closeText');

        		/**
        		 * called when function is instantiated
        		 * initialize tooltip with options
        		 */
        		self.initTooltip = function () {
        			//Get Target
        			self.target   = $(elements);
        			self.selector = self.target.selector;
        			self.length   = self.target.length;
        			self.source   = $();
        			self.isvisible= false;
        			self.refresh = function() {
        				self.target = $(self.selector);
        				self.length = self.target.length;
        			};

        			// Merge options with defaults
        			self.settings      = $.extend({
        				name	  	  : '',
        				trigger		  : 'click',
        				title         : '',
        				subtitle      : '',
        				text       	  : '',
        				html      	  : '',
        				htmlref    	  : '',
        				cssClass	  : '',
        				width         : '',
        				height        : '',
        				position      : 'auto',
        				zIndex        : 9999,
        				showTitle     : true,
        				showClose     : true,
        				showArrow     : true,
        				animation     : true,
        				closeOnEscape : true,
        				touchDevice	  : false,
        				mobile		  : false,
        				visible	  	  : true,
        				onOpen	      : function(){},
        				onClose	      : function(){},
        				onBeforeOpen  : function(){},
        				onBeforeClose : function(){}
        			}, options || {});

        			//Initialize Variables
        			_HTML = '<div class="aa-tooltip" role="tooltip" aria-labelledby="tooltipTitle" aria-describedby="tooltipWrapper">'
        					  + 	'<div class="tooltip-wrapper" id="tooltipWrapper" aria-atomic="true">'
        					  + 		'<h5 class="tooltip-title" id="tooltipTitle"></h5>'
        					  + 		'<p class="tooltip-subtitle"></p>'
        					  + 		'<div class="tooltip-content"></div>'
        					  +     '</div>'
        					  + 	'<div class="tooltip-arrow"><div class="tooltip-arrow-inner"></div></div>'
        					  + 	'<button type="button" id="closeTooltip" class="tooltip-close btn-link"><span class="icon-close icon-medium" aria-hidden="true"></span><span class="hidden-accessible">'+_tooltipCloseText+'</span></button>'
        					  + '</div>';
        			self.tooltip = $(_HTML);
        			self.name	 = (self.settings.name !== '') ? self.settings.name : _getSize(aaTooltips).toString();
        			_ua          = AA.browser;
        			_ua.version  = document.documentMode || _ua.version;
        			_clickEvent  = (self.settings.touchDevice) ? 'touchstart' : 'click';
        			_fade        = !(_ua.msie && _ua.version <= 8);
        			_animate     = true;


        			if (self.settings.width === '') {
        				self.settings.width = '300';
        			}

        			//Initialize Events
        			_bindOpenEvent();
        			_bindDocumentEvent();
        			_bindKeydownEvent();
        			if(self.settings.touchDevice){
        				_bindOrientationChangeEvent();
        			}
        			else{
        				_bindResizeEvent();
        			}

        		};
        		/**
        		 * opens tooltip and fires onOpen events
        		 */
        		self.openTooltip = function (source) {
        			self.refresh();
        			if (self.target.length === 0) return false;
        			if (!_settings('visible')) return false;
        			if (source === undefined) {
        				var animate = false;
        				source = self.target.filter(':first');
        			}

        			self.removeTooltip(); //Remove Tooltip if visible
        			self.source = $(source).filter(":first");
        			//Local Variables
        			var _title    = _settings('title');
        			var _subtitle = _settings('subtitle');
        			var _text     = _settings('text');
        			var _htmlref  = _settings('htmlref');
        			
        			if (self.source.is('button')) {
        				if (self.source.data('href') !== undefined) {
        					_htmlref = self.source.data('href');
        				}
        			} 
        			
        			_htmlref = (_htmlref !== '') ? _htmlref : self.source.attr('href') || '';
        			
        			
        			var _html     = (_htmlref !== '' && $(_htmlref).length > 0) ? $(_htmlref).html() : self.settings.html;
        			var _content  = (_html !== '') ? _html : _text;
        			if (_title === '' && _subtitle === '' && _content === '') return false;

        			//Tooltip Settings
        			self.tooltip = $(_HTML);
        			self.tooltip.removeAttr('style');
        			self.tooltip.find('*').removeAttr('style');
        			if (!_settings('showTitle') || _title === '') self.tooltip.find(".tooltip-title").remove();
        			if (_subtitle === '') 				self.tooltip.find(".tooltip-subtitle").remove();
        			if (_content === '') 				self.tooltip.find(".tooltip-content").remove();
        			if (!_settings('showClose'))		self.tooltip.find(".tooltip-close").remove();
        			if (!_settings('showArrow'))		self.tooltip.find(".tooltip-arrow").remove();
        			if (_settings('cssClass') !== '') 	self.tooltip.addClass(_settings('cssClass'));
        			if (_settings('width') !== '')		self.tooltip.css( 'width', _settings('width') );
        			if (_settings('height') !== '')		self.tooltip.css( 'height', _settings('height') );
        			if (_settings('zIndex') > 0)		self.tooltip.css( 'z-index', _settings('zIndex') );
        			if (_fade)							self.tooltip.css( 'opacity', 0 );
        			self.tooltip.find(".tooltip-title").html( _title );
        			self.tooltip.find(".tooltip-subtitle").html( _subtitle );
        			self.tooltip.find(".tooltip-content").html( _content );
        			self.tooltip.find(".tooltip-text").html( _text );
        			self.tooltip.find(".tooltip-title").attr('id','tooltipTitle');

        			//OnBeforeOpen Callback
        			var _result = self.settings.onBeforeOpen(self);
        			if (_result === false) return _result;
        			self.tooltip.insertAfter(self.source);

        			if(_settings('width') === 'auto'){
        				self.tooltip.css( 'width', self.tooltip.outerWidth() + 15 );
        			}
        			//Render Tooltip
        			_renderTooltip(self.source);

        			// Bind Events
        			_bindHoverEvent();
        			_bindClickEvent();

        			//OnOpen Callback
        			self.settings.onOpen(self);
        			self.tooltip.attr('tabindex','0').focus();
        		};
        		/**
        		 * close tooltip and fires onClose events
        		 */
        		self.closeTooltip = function () {
        			if (self.target.length === 0) return false;
        			if (!self.tooltip.is(':visible')) return false;

        			var _result = self.settings.onBeforeClose(self);
        			if (_result === false) return _result;

        			if (_settings('animation')) {
        				var _top = (self.tooltip.hasClass('top')) ? "+=10" : "-=10";
        				_animateTooltip(_top, 0, 200, function(){
        					$(this).remove();
        				});
        			} else {
        				self.tooltip.remove();
        			}
        			self.settings.onClose(self);
        			var _tooltipHasFocus = (self.tooltip.filter(':focus').length > 0 || self.tooltip.find('*:focus').length > 0);
        			if (_tooltipHasFocus) {
        				self.source.focus();
        			}
        			self.source = $();
        			self.isvisible = false;
        		};
        		/**
        		 * removes tooltip from DOM
        		 */
        		self.removeTooltip = function () {
        			if (self.target.length === 0) return false;
        			if (!self.tooltip.is(':visible')) return false;
        			self.tooltip.remove();
        			self.source = $();
        			self.isvisible = false;
        		};


        		/*******************************
        		 * Private Methods/Functions
        		 *******************************/
        		/**
        		 * called by openTooltip
        		 * gets tooltip settings from source or options
        		 */
        		var _settings = function(name) {
        			var _s = self.settings[name];
        			var _v = self.source.attr('data-tooltip-'+name) || _s;
        			if (typeof(_s)==='boolean') _v = (String(_v).toLowerCase()==='true');
        			if (typeof(_s)==='number') _v = parseInt(_v);
        			return _v;
        		};
        		/**
        		 * called by initTooltip
        		 * binds tooltip trigger event
        		 */
        		var _bindOpenEvent = function() {
        			if (self.settings.trigger === 'hover' || self.settings.trigger === 'click') {
        				var triggerEvent = (self.settings.trigger === 'hover') ? "mouseenter" : self.settings.trigger;
        				self.target.on(triggerEvent, function() {
        					self.openTooltip(this);
        				});
        			}
        		};
        		/**
        		 * called by initTooltip
        		 * removes tooltip when document is clicked
        		 */
        		var _bindDocumentEvent = function() {
        			if (self.settings.trigger === 'click') {
        				self.target.on(_clickEvent , function(ev){
        					return _stopEventPropagation(ev);
        				});
        			}
        			$(document).bind(_clickEvent, function(e) {
        				self.closeTooltip();
        			});
        		};
        		/**
        		 * called by initTooltip
        		 * removes tooltip when Esc Key is pressed
        		 */
        		var _bindKeydownEvent = function() {
        			if (self.settings.closeOnEscape) {
        				var escKey = 27;
        				$(document).bind('keydown', function(ev) {
        					if (ev.keyCode === escKey) {
        						self.closeTooltip();
        					}
        				});
        			}
        		};
        		/**
        		 * called by initTooltip
        		 * removes tooltip when window is resize
        		 */
        		var _bindResizeEvent = function() {
        			$(window).bind('resize', function(e) {
        				self.closeTooltip();
        			});
        		};
        		/**
        		 * called by initTooltip
        		 * removes tooltip when orientation changes
        		 */
        		var _bindOrientationChangeEvent = function() {
        			$(window).bind('orientationchange', function() {
        				self.removeTooltip();
        			});
        		};
        		/**
        		 * called by bindClickEvent and _bindDocumentEvent
        		 * stops click event from reaching document
        		 */
        		var _stopEventPropagation = function(ev) {
        			ev.stopPropagation();
        			ev.stopImmediatePropagation();
        			if (self.settings.touchDevice) { return; }
        			return false;
        		};
        		/**
        		 * called by openTooltip
        		 * binds tooltip hover event
        		 */
        		var _bindHoverEvent = function() {
        			if (self.settings.trigger === 'hover') {
        				self.tooltip.find(".tooltip-close").hide();
        				self.target.on("mouseleave", function() {
        					self.closeTooltip();
        				});
        			}
        		};
        		/**
        		 * called by openTooltip
        		 * binds close/tooltip click event
        		 */
        		var _bindClickEvent = function() {
        			if (self.settings.trigger === 'click') {
        				self.tooltip.find(".tooltip-title").css({'paddingRight':'20px'});
        				self.tooltip.find(".tooltip-close").show();
        				self.tooltip.find(".tooltip-close").bind('click', function(ev){
        					self.closeTooltip();
        					return false;
        				});
        				self.tooltip.bind(_clickEvent , function(ev){
        					return _stopEventPropagation(ev);
        				});
        			}
        		};
        		/**
        		 * called by openTooltip
        		 * renders tooltip based on target's position
        		 */
        		var _renderTooltip = function(target) {
        			if (self.target.length === 0) return false;

        			var pos_left = target.position().left + ( target.outerWidth() / 2 ) - ( self.tooltip.outerWidth() / 2 );
        			var offset_left = target.offset().left + ( target.outerWidth() / 2 ) - ( self.tooltip.outerWidth() / 2 );
        			var browserWidth = $(window).width();
        			var maxWidth = self.tooltip.outerWidth() + 20;
        			var smallWindow = (maxWidth > browserWidth) ? true : false;
        			var tooltipArrow = self.tooltip.find(".tooltip-arrow");

        			//Position Tooltip
        			pos_left = _initializePositionLeft(offset_left, smallWindow, pos_left, browserWidth, target, tooltipArrow);

        			if(smallWindow) {
        				self.tooltip.css( { 'width': browserWidth - 10 } );
        			}

        			var	pos_top  = target.offset().top - self.tooltip.outerHeight() - 25;
        			pos_top  = _initializePositionTop(pos_top, target);

        			//Display Tooltip
        			self.tooltip.css( { 'left': pos_left, 'top': pos_top } );
        			if (_settings('animation') && _animate) {
        				var _top = (self.tooltip.hasClass('top')) ? "-=10" : "+=10";
        				_animateTooltip(_top, 1, 300);
        			} else {
        				var _top = (self.tooltip.hasClass('top')) ? pos_top-10 : pos_top+10;
        				self.tooltip.css({ 'top': _top });
        				if (_fade) {
        					self.tooltip.css({ 'opacity': 1 });
        				}
        				self.tooltip.show();
        			}
        			_animate = true;
        			self.isvisible = true;
        		};
        		/**
        		 * called by renderTooltip and closeTooltip
        		 * hides/shows tooltips with animation
        		 */
        		var _animateTooltip = function(_top,_opacity,_delay,_callback) {
        			if (_callback === undefined) _callback = function(){};
        			if (_fade) {
        				self.tooltip.stop(true).animate( { 'top': _top, 'opacity': _opacity }, _delay, _callback );
        			} else {
        				self.tooltip.stop(true).animate( { 'top': _top }, _delay, _callback );
        			}
        		};

        		/**
        		 * called by renderTooltip
        		 * add/removes Tooltip class 'left' or 'right' for positioning of arrow
        		 * returns the 'x' coordinate of the Tooltip
        		 */
        		var _initializePositionLeft = function(offset_left, smallWindow, pos_left, browserWidth, target, tooltipArrow){
        			self.tooltip.removeClass( 'left' );
        			self.tooltip.removeClass( 'right' );
        			tooltipArrow.css('left','');
        			var distanceFromLeft = target.offset().left - target.position().left;
        			var distanceFromRight = browserWidth - (target.offset().left + target.outerWidth());

        			if( (offset_left + self.tooltip.outerWidth() > browserWidth) && !smallWindow ){
        				pos_left = target.position().left + target.outerWidth() + distanceFromRight - self.tooltip.outerWidth() - 8;
        				_initializeArrowPosition(target, pos_left, distanceFromRight, tooltipArrow);
        			}
        			else if( (distanceFromLeft + pos_left < 0) || smallWindow ){
        				pos_left = 5 - distanceFromLeft;
        				_initializeArrowPosition(target, pos_left, distanceFromRight, tooltipArrow);
        			}

        			return pos_left;
        		};

        		var _initializeArrowPosition = function(target, pos_left, distanceFromRight, tooltipArrow){
        			if((target.offset().left + ( target.outerWidth() / 2 )) <= 18){
        				self.tooltip.addClass( 'left' );
        			}
        			else if( (distanceFromRight + ( target.outerWidth() / 2 )) <= 18){
        				self.tooltip.addClass( 'right' );
        			}
        			else{
        				var arrow_posLeft = target.position().left - pos_left + ( target.outerWidth() / 2 ) - 2;
        				tooltipArrow.css('left', arrow_posLeft);
        			}
        		}

        		/**
        		 * called by renderTooltip
        		 * add/removes Tooltip class 'top' for top positioning of arrow
        		 * returns the 'y' coordinate of the Tooltip
        		 */
        		var _initializePositionTop = function(pos_top, target){
        			var belowTarget = false;
        			if (_settings('position') === '' || _settings('position') === 'auto') {
        				if( (pos_top < 0) || (pos_top < _getScrollTop() ) ) {
        					belowTarget = true;
        				}
        			} else if (_settings('position') === 'below') {
        				belowTarget = true;
        			}
        			if( belowTarget ) {
        				pos_top = _getPosTop(target) + target.outerHeight() + 25;
        				self.tooltip.addClass( 'top' );
        			} else {
        				pos_top = _getPosTop(target) - self.tooltip.outerHeight() - 25;
        				self.tooltip.removeClass( 'top' );
        			}

        			return pos_top;
        		};
        		/**
        		 * called by getScrollTop
        		 * Finds the scrolltop position of the document
        		 * Fixes jQuery IE issue (jQuery 1.4 or lower)
        		 */
        		var _getScrollTop = function(){
        			var _scrolltop = $(document).scrollTop();
        			return _scrolltop;
        		};
        		/**
        		 * called by getPosTop
        		 * Finds the y position of an element
        		 * Fixes jQuery IE issue (jQuery 1.4 or lower)
        		 */
        		var _getPosTop = function(target){
        			var _top = target.position().top;
        			return _top;
        		};
        		/**
        		 * called by initTooltip
        		 * finds the size of an object to support all browsers
        		 */
        		var _getSize = function(object){
        			var size = 0;
        			for (var x in object) {
        				size++;
        			}
        			return size;
        		};

        		// Default Initialization
        		self.initTooltip();
        	});
        };

        var tooltip = self.aaTooltip(self.source, options);
        if (aaTooltips !== undefined && tooltip.name !== undefined && tooltip.name !== '') {
            aaTooltips[tooltip.name] = tooltip;
        }
        return tooltip;
    };
})(jQuery);
